import ApiClient from './ApiClient';

class ContactAssignmentsAPI extends ApiClient {
  constructor() {
    super('contact_assignments', { accountScoped: true });
  }
}

export default new ContactAssignmentsAPI();
